function initScrollRevealAnimations() {

	var scrollReveal = $('.sr');

	if (scrollReveal.length) {
		var controllerScroll = new ScrollMagic.Controller();

		scrollReveal.each(function () {
			var element = $(this);
			var offset = element.offset().top;
			var windowHeight = $(window).height();

			var scene = new ScrollMagic.Scene({
				triggerHook: "onLeave",
				offset: offset - (windowHeight * 0.85),
				reverse: false
			});
			scene.on('start', function (e) {
				if (e.scrollDirection != 'REVERSE') {
					element.trigger('reveal');
					scene.remove();
				}

			});
			scene.addTo(controllerScroll);
		});
		$('.page-container').data('scrollController', controllerScroll);
	}

	// NUMBER
	if (!isTouch) {
		$('.sr--number').on('reveal', function () {
			if ($(this).hasClass('is-revealed')) {
				return;
			}

			if ($(this).data('price-start')) {
				price_start = $(this).data('price-start');
			} else {
				price_start = 100;
			}
			$(this).addClass('is-revealed');
			$(this).prop('number', price_start);

			var floatStep = function (now, tween) {
				var formatted = now.toFixed(2); // 2 décimales
				$(tween.elem).text(formatted);
			};

			const price = $(this).data('price');
			const isFloat = /[.,]/.test(price);

			if (isFloat) {
				$(this).animateNumber({
					number: price,
					easing: 'easeInQuad',
					numberStep: floatStep
				}, 2000);
			} else {
				$(this).animateNumber({
					number: price,
					easing: 'easeInQuad'
				}, 2000);
			}

		});
	}

	// SCHEDULE
	$('.sr--schedule').on('reveal', function () {
		if ($(this).hasClass('is-revealed')) {
			return;
		}

		$('#schedule').animate({scrollLeft: 0}, 1200);
		setTimeout(function () {
			$('.schedule_anim').addClass('schedule_anim--hidden');
		}, 3000);
	});
}
